import React from "react";

import Typography from "@material-ui/core/Typography";

import { useStyles } from "./results-page-styles";
import ResultsTable from "./results-table";
import InputsButton from "./inputs-button";

export default ({ age, startingCapital, monthlyDeposit, riskToleranceMod }) => {
  const classes = useStyles();

  return (
    <main className={classes.root}>
      <Typography className={classes.header} component="h1" variant="h4">
        Мой результат<sup>*</sup>
        <span role="img" aria-label="rising chart">
          {" "}
          📈
        </span>
      </Typography>
      <ResultsTable
        age={age}
        startingCapital={startingCapital}
        monthlyDeposit={monthlyDeposit}
        riskToleranceMod={riskToleranceMod}
      />
      <InputsButton />
      <Typography className={classes.tableCaption} variant="caption">
        <sup>*</sup>
        Возможный капитал без учета налога и с увеличением % при увеличении
        накопленной суммы.
      </Typography>
    </main>
  );
};
